import axios from 'axios'
import {
  SpendChartRequestParams,
  SpendChartResponse,
} from 'src/queries/reporting/reporting.models'
import { getRequestConfig } from 'src/queries/requestConfig'

export const fetchSpendChart = async ({
  chart,
  since,
  until,
  currency,
  // organizationId is used for query cache keying only; the auth bearer token scopes the response to the org
  organizationId: _organizationId,
}: SpendChartRequestParams): Promise<SpendChartResponse> => {
  const requestConfig = getRequestConfig()
  const response = await axios.get<SpendChartResponse>(
    '/reporting/spend-dashboard',
    {
      ...requestConfig,
      params: {
        chart,
        since,
        until,
        currency,
      },
    },
  )
  return response.data
}
